import React from 'react';
import { motion } from 'framer-motion';
import { ExternalLinkIcon } from 'lucide-react';
export function CatalogSection() {
  return <section className="bg-white py-6 sm:py-8 px-4 sm:px-6 lg:px-8" data-id="element-38">
      <motion.div initial={{
      opacity: 0,
      y: 12
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5
    }} className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center gap-4 sm:gap-6" data-id="element-39">
        {/* Logo with subtle shadow to make it pop */}
        <img src="https://cdn.magicpatterns.com/uploads/32hx1FcyBB6PsWiyMp1As4/logo_png_recursos_fitness.png" alt="Recursos Fitness logo" className="w-20 h-20 sm:w-24 sm:h-24 object-contain drop-shadow-md flex-shrink-0" data-id="element-40" />

        {/* Text */}
        <div className="flex-1 text-center sm:text-left" data-id="element-41">
          <h2 className="text-lg sm:text-xl font-extrabold text-navy-900 leading-tight" data-id="element-42">
            Accedé a nuestro catálogo completo
          </h2>
          <p className="text-gray-500 text-xs sm:text-sm mt-1" data-id="element-43">
            Planificaciones, guías, material didáctico y mucho más.
          </p>
        </div>

        {/* CTA */}
        <motion.a href="https://www.recursosfitness.shop" target="_blank" rel="noopener noreferrer" whileHover={{
        scale: 1.03
      }} whileTap={{
        scale: 0.97
      }} className="inline-flex items-center gap-2 bg-navy-900 hover:bg-navy-800 text-white font-bold text-sm px-6 py-2.5 rounded-lg shadow-md transition-colors whitespace-nowrap flex-shrink-0" data-id="element-44">
          <ExternalLinkIcon className="w-4 h-4" data-id="element-45" />
          Ver catálogo
        </motion.a>
      </motion.div>
    </section>;
}